import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export function useTrafficSummaryMetrics(
  userId: string,
  dateRange: { startDate: string; endDate: string },
  isMarketingUser: boolean,
) {
  return useQuery({
    queryKey: [
      "traffic-summary-metrics",
      userId,
      dateRange.startDate,
      dateRange.endDate,
      isMarketingUser,
    ],
    queryFn: async () => {
      if (isMarketingUser) {
        const response = await api.getAnalytics(userId, {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          analyticsType: "WebsiteTrafficByDevice",
        });
        const totalTraffic = (response as any[]).reduce(
          (sum: number, r: any) => sum + Number(r.count || 0),
          0,
        );
        return { totalWebsiteTraffic: { current: totalTraffic } };
      }

      const response = await api.getMetrics(userId, {
        type: "TotalRevenue",
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      });
      return {
        revenue: response.revenue,
        roomsSold: response.bookings,
        websiteVisits: response.visits,
        avgTimePerVisit: response.userEngagement,
      };
    },
    enabled: !!userId && !!dateRange.startDate && !!dateRange.endDate,
    staleTime: 5 * 60 * 1000,
  });
}
